// extracted by css-extract-rspack-plugin
export default {"grid":"grid-JOerLc","item":"item-w6YzER","footer":"footer-nvWCmj"};